module.exports = __webpack_public_path__ + "static/media/t3.eacce53d.svg";